/**
 * @generated SignedSource<<0402b13ccaf8b7feea76e20674513edf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "serviceId",
        "variableName": "serviceId"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "ToggleServiceFavorite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rowId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isUserFavorite",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceDetailCardMutation",
    "selections": (v1/*: any*/),
    "type": "ClientAppMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServiceDetailCardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c0e5e3d749bf66806b2cd00585d407e4",
    "id": null,
    "metadata": {},
    "name": "ServiceDetailCardMutation",
    "operationKind": "mutation",
    "text": "mutation ServiceDetailCardMutation(\n  $serviceId: Int!\n) {\n  ToggleServiceFavorite(serviceId: $serviceId) {\n    id\n    rowId\n    name\n    isUserFavorite\n  }\n}\n"
  }
};
})();

node.hash = "fa7c68053ad277458015e65fa624b6bb";

module.exports = node;
